import { Caller } from "../callInWorker";
import { Request, Progress, Response } from "./types";

export default new Caller<Request, Progress, Response>(
  new Worker("./gifEncoder.worker.ts", { type: "module" })
);
